import { render, staticRenderFns } from "./BankPicker.vue?vue&type=template&id=81c08b4c&scoped=true&"
import script from "./BankPicker.vue?vue&type=script&lang=ts&"
export * from "./BankPicker.vue?vue&type=script&lang=ts&"
import style0 from "./BankPicker.vue?vue&type=style&index=0&id=81c08b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c08b4c",
  null
  
)

export default component.exports